import React from 'react';
import './ConfirmLoadsModal.scss';
import Modal from 'react-bootstrap/Modal';
import { CustomButton } from '../_common';
import { useStoreContext } from '../App/StoreProvider';

interface ConfirmLoadsModalProps {
    numberOfLoadsToCreate?: number;
    tmsIds?: number[];
    onClickNext: () => void;
    onClickHide: () => void;
    show: boolean;
}

const ConfirmLoadsModal = ({ show, onClickNext, onClickHide }: ConfirmLoadsModalProps): React.ReactElement => {
    const [state] = useStoreContext();
    const {
        addLoadModal: { numberOfLoadsToCreate },
    } = state;
    return (
        <Modal show={show} onHide={onClickHide} backdrop="static">
            <Modal.Header className="ConfirmLoadsModal-Header">
                <Modal.Title className="ConfirmLoadsModal-Header-Container">
                    <i className="material-icons ConfirmLoadsModal-X-Button" onClick={onClickHide}>
                        close
                    </i>
                    <div className="ConfirmLoadsModal-Title">Add Loads</div>
                </Modal.Title>
            </Modal.Header>
            <Modal.Body className="ConfirmLoadsModal-Body">
                <div className="ConfirmLoadsModal-Body-Header">{`Are you sure you want to create ${numberOfLoadsToCreate} loads?`}</div>
            </Modal.Body>
            <Modal.Footer className="ConfirmLoadsModal-Footer">
                <CustomButton title="Cancel" isBordered onClick={onClickHide}></CustomButton>
                <CustomButton title="Continue" isDisabled={false} onClick={onClickNext}></CustomButton>
            </Modal.Footer>
        </Modal>
    );
};

export default ConfirmLoadsModal;

